import __unimport_store from '@/store/store.js';import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '@/assets/images/logo/cicil_logo_w.svg';
import _imports_1 from '@/assets/images/icon/delete.png';
var _hoisted_1 = {
  class: "popup popup-tablet-fullscreen popup-sty-modal popup-bg-apple popup-codes",
  id: "popup-codes"
};
var _hoisted_2 = {
  class: "view"
};
var _hoisted_3 = {
  class: "page"
};

var _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"navbar\"><div class=\"navbar-inner\"><div class=\"left\"></div><div class=\"title\"></div><div class=\"right\"></div></div></div>", 1);

var _hoisted_5 = {
  class: "page-content popup-modal-centered"
};
var _hoisted_6 = {
  class: "page-inner"
};
var _hoisted_7 = {
  class: "popup-modal-content no-bg"
};
var _hoisted_8 = {
  class: "head-card"
};

var _hoisted_9 = /*#__PURE__*/_createVNode("div", {
  class: "card-head"
}, [/*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "",
  srcset: ""
}), /*#__PURE__*/_createTextVNode(" 會員條碼 ")], -1);

var _hoisted_10 = {
  class: "card-body"
};
var _hoisted_11 = {
  key: 1,
  class: "text-align-center margin-bottom text-bold"
};

var _hoisted_12 = /*#__PURE__*/_createVNode("div", {
  class: "description"
}, " 出示會員條碼，將可記錄門市集點資訊，此條碼可至全台喜美超市累點使用。 ", -1);

var _hoisted_13 = {
  class: "head-card sty-sec"
};

var _hoisted_14 = /*#__PURE__*/_createVNode("div", {
  class: "card-head"
}, " 手機載具條碼 ", -1);

var _hoisted_15 = {
  class: "card-body"
};
var _hoisted_16 = {
  key: 1,
  class: "text-align-center margin-bottom text-bold"
};

var _hoisted_17 = /*#__PURE__*/_createVNode("a", {
  class: "link popup-close popup-close-auto popup-tail-close"
}, [/*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "",
  srcset: ""
})], -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_BaseBarcode = _resolveComponent("BaseBarcode");

  return _openBlock(), _createBlock("div", _hoisted_1, [_createVNode("div", _hoisted_2, [_createVNode("div", _hoisted_3, [_hoisted_4, _createVNode("div", _hoisted_5, [_createVNode("div", _hoisted_6, [_createVNode("div", _hoisted_7, [_createVNode("div", _hoisted_8, [_hoisted_9, _createVNode("div", _hoisted_10, [$setup.memberCard ? (_openBlock(), _createBlock(_component_BaseBarcode, {
    key: 0,
    width: "2",
    height: "60",
    codeValue: $setup.memberCard
  }, null, 8, ["codeValue"])) : (_openBlock(), _createBlock("div", _hoisted_11, " 尚無資料 ")), _hoisted_12])]), _createVNode("div", _hoisted_13, [_hoisted_14, _createVNode("div", _hoisted_15, [__unimport_store.state.auth.vehicle ? (_openBlock(), _createBlock(_component_BaseBarcode, {
    key: 0,
    width: "2",
    height: "60",
    codeValue: __unimport_store.state.auth.vehicle
  }, null, 8, ["codeValue"])) : (_openBlock(), _createBlock("div", _hoisted_16, " 尚無資料 "))])]), _hoisted_17])])])])])]);
}